import { FC, useEffect, useState } from 'react';
import { Select } from 'antd';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import asyncErrorHandler from 'src/utils/asyncErrorHandler';

interface RequestsSelectProps {
  projectUuid?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const RequestsSelect: FC<RequestsSelectProps> = ({ projectUuid, value, onChange }) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!projectUuid) return;

    setLoading(true);
    apiRequests
      .get(apiRoutes.PROJECT_REQUEST, {
        'page[size]': 100,
        'filters[project.uuid][]': projectUuid,
        'filters[projects_requests.status]': [
          'draft', 'new', 'waiting_approval',
          'needs_attention', 'approved', 'in_progress',
        ],
      })
      .then((res) => {
        setOptions(
          res.data.data.map((req: any) => ({
            label: req.subject ?? 'Untitled',
            value: req.uuid,
          }))
        );
      })
      .catch(asyncErrorHandler)
      .finally(() => setLoading(false));
  }, [projectUuid]);

  return (
    <Select
      mode="multiple"
      loading={loading}
      placeholder="Select requests..."
      options={options}
      value={value}
      onChange={onChange}
      style={{ width: '100%' }}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default RequestsSelect;
